// NOTE: we also create a global variable to make the access from templates easier
define('core/i18n', ['lib/underscore', 'core/obj'], function (_, JsObject) {
    return window.i18n = new (JsObject.extend(function () {
        var data;
        var noMatch = /(.)^/;
        var settings = {
            escape: noMatch,
            evaluate: noMatch,
            interpolate: /\{\{(.+?)\}\}/g,
        };
        return {
            define: function (resources) {
                if (resources != null) {
                    if (!_.isObject(resources)) {
                        resources = { };
                        resources[arguments[0]] = (arguments[1] || '').toString();
                    }

                    data = _.extend(data || { }, resources);
                }
            },
            get: function (resource, model) {
                resource = trimPrefix(resource, 'GlobalResources.');
                var ret = data && data[resource];

                // Keep consistent with the logic in AdsAppUISharedComponents
                // AdsAppUISharedComponents/private/client-universal/packages/i18n-model/src/resource.js
                // AdsAppUISharedComponents/private/client-universal/packages/primitive-utilities/src/string.ts
                if (model) {
                    var curlyTemplate = _.template(ret, settings);
                    ret = curlyTemplate(model);
                }

                return ret;
            },
            getString: JsObject.aliasFor('get')
        };

        function trimPrefix(str, prefix) {
            var prefixLen = (_.isString(prefix) && prefix.length) || 0;
            if (_.isString(str) && str.slice(0, prefixLen) === prefix) {
                return str.slice(prefixLen);
            } else {
                return str;
            }
        }
    }))();
});
